var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 32 x 33",
    clipPath: "url(#clip0_1006_1824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.619 24.8408L17.672 20.4071C16.7612 18.3315 16.9761 15.9734 18.2478 14.0986L19.9931 11.5241L21.3493 13.5605C22.7515 15.6666 22.8084 18.4253 21.4959 20.5878L20.8815 21.6C20.6603 21.9642 20.6195 22.4102 20.7695 22.809L21.2712 24.1411C21.3016 24.106 21.3298 24.068 21.3551 24.0266L22.9176 21.4532C24.5646 18.74 24.4922 15.2794 22.7331 12.6375L20.0058 8.54102L16.8715 13.1629C15.2757 15.5159 15.0056 18.4748 16.1497 21.078L18.0967 25.5124C18.9231 27.394 18.9535 29.4794 18.1823 31.3847C18.1134 31.5562 18.0387 31.723 17.9582 31.887L14.8579 30.0779C12.1523 28.4989 8.84628 28.355 6.01432 29.6906L-0.000732422 32.5287L6.00857 36.3208C7.54523 37.2904 9.30946 37.7847 11.0835 37.7847C12.2972 37.7847 13.5149 37.5528 14.6659 37.0838C16.987 36.1378 18.7829 34.3355 19.7236 32.0102C20.6643 29.6843 20.627 27.1385 19.6184 24.8414L19.619 24.8408ZM14.039 35.5405C11.7012 36.494 9.03132 36.2586 6.89528 34.9115L3.45532 32.7398L6.72403 31.1971C9.06178 30.0946 11.7892 30.2137 14.0212 31.5165L17.0663 33.2928C16.2756 34.2774 15.2446 35.0496 14.0401 35.5405H14.039Z",
    fill: "#094B38",
    stroke: "#094B38",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.9844 29.6911C31.1524 28.3549 27.8458 28.4999 25.1385 30.0795L22.7571 31.4807C22.252 31.7782 21.8589 32.2339 21.6394 32.7777L21.6359 32.7857C21.3721 33.436 21.0549 34.0523 20.6877 34.6306L25.9792 31.5169C28.2113 30.2141 30.9386 30.095 33.2758 31.1975L36.5451 32.7403L33.104 34.912C32.6983 35.1681 32.2661 35.3879 31.8202 35.5657C30.9358 35.9173 29.9611 36.0962 28.9221 36.0962H20.5665C19.9665 36.0962 19.389 36.3264 18.9534 36.7396C18.585 37.0894 18.1925 37.4134 17.7776 37.7103C17.8672 37.7437 17.9638 37.7615 18.0649 37.7615H28.9227C30.1732 37.7615 31.3547 37.5435 32.4356 37.113C32.9753 36.8978 33.4988 36.6314 33.9913 36.3207L40 32.5285L33.9855 29.6899L33.9844 29.6911Z",
    fill: "#094B38",
    stroke: "#094B38",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3503 27.3801V25.5088C12.3503 24.7687 12.1744 24.0402 11.8405 23.3802C9.53784 18.8291 10.1838 13.203 13.5732 9.29756L14.7139 7.98384C15.1518 7.47918 15.3926 6.8347 15.3926 6.16661V4.66357L12.3181 8.20481C10.2671 10.567 9.06432 13.4654 8.83732 16.586C8.61091 19.7078 9.38326 22.7495 11.0711 25.3833L12.3497 27.3795L12.3503 27.3801Z",
    fill: "#094B38",
    stroke: "#094B38",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.3137 9.29805C29.7031 13.2035 30.3485 18.8296 28.0464 23.3807C27.7125 24.0407 27.5366 24.7692 27.5366 25.5087V27.38L28.8153 25.3838C30.5025 22.75 31.2754 19.7083 31.0484 16.5865C30.822 13.4654 29.6187 10.5669 27.5682 8.2053L24.4938 4.66406V6.1671C24.4938 6.83461 24.7346 7.47967 25.1719 7.98433L26.3132 9.29805H26.3137Z",
    fill: "#094B38",
    stroke: "#094B38",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 19.9987,
    cy: 4.14716,
    r: 2.00002,
    stroke: "#094B38",
    strokeWidth: 1.33334
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_1824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.c5d454956db70d525f8870ff7ee40fde.svg";
export { ForwardRef as ReactComponent };